"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGIN_REDIRECT_URL = exports.LOGIN_PORTAL_ID = exports.CONFIRMATION = exports.LOGIN_TYPE = exports.EMAIL = void 0;
var EMAIL = 'email';
exports.EMAIL = EMAIL;
var LOGIN_TYPE = 'loginType';
exports.LOGIN_TYPE = LOGIN_TYPE;
var CONFIRMATION = 'CONFIRMATION';
exports.CONFIRMATION = CONFIRMATION;
var LOGIN_PORTAL_ID = 'loginPortalId';
exports.LOGIN_PORTAL_ID = LOGIN_PORTAL_ID;
var LOGIN_REDIRECT_URL = 'loginRedirectUrl';
exports.LOGIN_REDIRECT_URL = LOGIN_REDIRECT_URL;